module.exports = __webpack_public_path__ + "img/kc16.43e4d5e0.png";